import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../entities';
import { TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { ForgeGdriveEugeneTestProdIcon } from './icon';
import { ForgeGdriveEugeneTestProdSearchResultIcon } from './search-result-icon';

export const forgeGdriveEugeneTestProdConfig: ThirdPartyConfig = {
	displayName: 'Forge GDrive Eugene Test PROD',
	id: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
	resourceType: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
	icon: get3PLogo(ForgeGdriveEugeneTestProdIcon, 'ForgeGdriveEugeneTestProd', 'medium'),
	searchResultIcon: get3PLogo(
		ForgeGdriveEugeneTestProdSearchResultIcon,
		'ForgeGdriveEugeneTestProd',
		'large',
	),
	integrationAri: 'ari:cloud:platform::integration/bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: false,
	isEnabled: () => true,
	displayWorkspaceNameAsProductName: true,
};
